import AppRouter from './routers'

function App() {
  return (
    <AppRouter />
  )
}

export default App;